<template>
    <div>
    <vue-modal
        v-model="modal.isVisible"
        :header="false"
        :footer="false"
        :backdrop="false"
        :closable="isPremium ? false : true"
        :modalBodyClass="$prefixClass.modal + '-plan-notificate '"
        @on-hide="onCancel"
    >
        <img class="m-b-16" src="@/assets/images/plan-notification.svg"/>
        <h4 :class="['m-b-12']">{{ $t('pricing.plan_notification.'+modal.type+'.title') }}</h4>
        <span v-html="$t('pricing.plan_notification.'+modal.type+'.description')"></span>
        <div :class="[$prefixClass.modal + '-plan-notificate__actions', 'm-t-24']">
            <!-- <a-button v-if="!isPremium" class="m-r-8" type="secondary" @click="onCancel">{{$t('pricing.buttons.maybe_later')}}</a-button> -->
            <a-button type="primary" @click="doAction">{{isPremium ? $t('pricing.buttons.approve_charge') : $t('pricing.buttons.go_to_pricing')}}</a-button>
        </div>
    </vue-modal>
    <model-voucher :data="voucher" :resetOnVoucher="resetOnVoucher" :resetOnChargePlan="resetOnChargePlan"></model-voucher>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { types as typesCharge } from '@/modules/charge/constant'
import cookie from 'js-cookie'
import ModelVoucher from "@/modules/charge/components/ModelVoucher";
export default {
    name: "VueModalTrialSucess",
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    components: {
        ModelVoucher
    },
    data() {
        return {
            voucher: {
                isVisibleModal: false,
                plan: null,
                name: "",
                discountCode: "",
                usedTrial: false
            },
            resetOnVoucher: 0,
            resetOnChargePlan: 0
        }
    },
    computed: {
        ...mapGetters({
            plans: typesCharge.getters.GET_PLANS
        }),
        modal: {
            get: function() {
                return this.value
            },
            set: function(newValue) {
                this.$emit('input', newValue)
            }
        },
        isPremium() {
            return this.modal.type === 'premium'
        }
    },
    created() {
        if (!this.plans) {
            this.getPlans()
        }
    },
    methods: {
        ...mapActions({
            getPlans: typesCharge.actions.GET_PLANS
        }),
        onCancel() {
            this.modal.isVisible = false
            cookie.set( 'hide-modal-plan-notification' , true , { expires: 30 })
        },
        doAction() {
            this.onCancel()
            if ( this.isPremium ) {
                this.onChargePlan({name: this.plans.premium.name})
            } else {
                this.$router.push({
                    name: this.$routerName.PRICING
                })
            }
        },
        onChargePlan({ name, discountCode = "", usedTrial = false}) {
            this.resetOnChargePlan += 1;
            this.voucher.name = name;
            this.voucher.discountCode = discountCode;
            this.voucher.usedTrial = usedTrial
            cookie.set('close-modal-trial-ended', true, { expires: 30 } )
        }
    }
}
</script>
<style lang="scss">
    .m-modal-plan-notificate {
        text-align: center;
        width: 520px !important;
        .m-modal {
            &-body {
                padding: 32px;
            }
            &-content {
                border-radius: 8px;
            }
        }
    }
    
</style>
